import {Steps, Divider, Form, Input, Button, Alert, notification} from 'antd';
import Container from "../components/Container";
import {MobileOutlined,UserOutlined, CheckCircleOutlined} from "@ant-design/icons"
import {Validation,RequestActivationCodeValidation} from "../utilis/tools/validation";
import {useContext, useEffect, useRef, useState} from "react";
import Urls from "../utilis/api/Urls";
import Api from "../utilis/api/service";

import {AxiosResponse} from "axios";
import LocalStorage from "../utilis/tools/LocalStorage";

import {useNavigate, useSearchParams} from "react-router-dom";
import AuthContext from "../utilis/contexts/AuthContext";
import Texts from "../utilis/defaults/Text";
import {ConvertPersianToEnglish} from "../utilis/helpers/convertor";

const Login = () => {
    const navigate=useNavigate();
    const authContext=useContext(AuthContext)
    const [searchParams]=useSearchParams();
    const isRegisterLetter=!!searchParams.get("register_letter");

    const {Step} = Steps;
    const [step, setStep] = useState(0);
    const [cellphone,setCellphone] = useState('')
    const [isLoading, setLoading] = useState(false);
    useEffect(()=>{


            if(!!authContext.user){
                    navigate('/panel')
            }else {

            }
    },[authContext.user])
    const handleRequestActivationCode = (values: any) => {
        setCellphone(ConvertPersianToEnglish(values.mobile))
        setLoading(true)
        const body={
            Cellphone:ConvertPersianToEnglish(values.mobile)
        }
        Api.post(Urls.requestActivationCode, body,{
            headers:{
                "Device-Id" :LocalStorage.getDeviceId(),
            }
        }).then((response:AxiosResponse) => {

            if(response.data.Status===-1){
                notification['error']({
                    message: response.data.Message,
                    duration: 120
                });
            }else {
                setStep(step+1)

            }

        }).catch(()=>{

        }).finally(()=>{
            setLoading(false)

        })
    }
    const handleVerifyActivationCode = (values: any) => {

        setLoading(true)
        const body={
            Cellphone:cellphone,
            Code:ConvertPersianToEnglish(values.activationCode)
        }

        Api.post(Urls.verifyActivationCode, body,{
            headers:{
                "Device-Id" :LocalStorage.getDeviceId(),
                "Authorization":`Basic ${btoa(ConvertPersianToEnglish(cellphone)+":"+LocalStorage.getDeviceId())}`
            }
        }).then((response:AxiosResponse) => {
            const {data}=response;
            const {Status,Message,Data}=data;
            if(Status==0){
                setStep(step+1)
            }else if (Status==1){

                authContext.handleUser(Data.user)
                LocalStorage.setUser(Data.user)
                if(isRegisterLetter){
                    navigate('/panel/letter/register-letter')
                }else {
                    navigate('/panel')
                }

            }else {
                notification['error']({
                    message: response.data.Message,
                    duration: 120
                });
            }
        }).catch(()=>{

        }).finally(()=>{
            setLoading(false)

        })
    }
    const onFinishFailed = (error: any) => {

    }
    const handleRegister=(values:any)=>{
        setLoading(true)
        const body={
            Cellphone:cellphone,
            Name:values.name,
            Password:LocalStorage.getDeviceId(),
            Type:"Client",
        }

        Api.post(Urls.registerUser, body,{
            headers:{
                "Device-Id" :LocalStorage.getDeviceId(),
                "Authorization":`Basic ${btoa(cellphone+":"+LocalStorage.getDeviceId())}`
            }
        }).then((response:AxiosResponse) => {
            const {data}=response;

            const {Status,Data}=data;

            if(Status===0){
                LocalStorage.setUser(Data.user);
                LocalStorage.setCellphone(cellphone);
                authContext.handleUser(Data.user);
                if(isRegisterLetter){
                    setTimeout(()=>{ navigate('/panel/letter/register-letter')},300)

                }else {
                    setTimeout(()=>{navigate('/panel')},300)
                }



            }else if(Status===-1){
                notification['error']({
                    message: response.data.Message,
                    duration: 120
                });
            }

        }).catch(()=>{

        }).finally(()=>{
            setLoading(false)

        })
    }
    return <Container className=" mt-20">
        <div className="w-full mx-auto md:w-8/12">
            <Steps size="small" current={step}>
                <Step title="درخواست کد فعالسازی" />
                <Step title="تایید کد فعالسازی" />
                <Step title="ورورد/ ثبت نام" />

            </Steps>
        </div>
        <Divider/>
        <div className="w-full   mx-auto rounded-lg bg-white px-5 pt-5 md:w-6/12">

        {step === 0 &&

                <Form     className="w-full flex flex-col"
                          layout='vertical'
                          onFinish={handleRequestActivationCode}
                          onFinishFailed={onFinishFailed}
                          autoComplete="off" scrollToFirstError={true}>
                    <Form.Item name="mobile" label="شماره موبایل" rules={[Validation(RequestActivationCodeValidation)]}>
                        <Input size="large" type="tel" prefix={<MobileOutlined/>} placeholder="مثلا ۰۹۲۱۰۹۱۵۳۲۳"/>
                    </Form.Item>
                    <Form.Item className="w-full  ">
                        <Button loading={isLoading} size="large" type="primary" className="bg-primary w-full  "
                                htmlType="submit">
                          مرحله بعد
                        </Button>
                    </Form.Item>
                </Form>
          }
            {step === 1 &&
                <>
                    <Alert className="mb-3 " type="success" banner  showIcon description="کد تایید برای شما ارسال گردید."/>
                    <div className="w-full py-2"/>
                    <Form     className="w-full      flex flex-col"
                              layout='vertical'
                              onFinish={handleVerifyActivationCode}
                              onFinishFailed={onFinishFailed}
                              autoComplete="off" scrollToFirstError={true}>
                        <Form.Item name="activationCode" label="کد تایید را وارد کنید" rules={[Validation(RequestActivationCodeValidation)]}>
                            <Input type="tel" size="large" prefix={<CheckCircleOutlined />} placeholder=" "/>
                        </Form.Item>
                        <Form.Item className="w-full  ">
                            <Button loading={isLoading} size="large" type="primary" className="bg-primary w-full  "
                                    htmlType="submit">
                                مرحله بعد
                            </Button>
                        </Form.Item>
                    </Form>
                </>

            }
            {step === 2 &&
                <>

                    <Form     className="w-full      flex flex-col"
                              layout='vertical'
                              onFinish={handleRegister}
                              onFinishFailed={onFinishFailed}
                              autoComplete="off" scrollToFirstError={true}>
                        <Form.Item name="name" label="نام" rules={[Validation(RequestActivationCodeValidation)]}>
                            <Input  size="large" prefix={<UserOutlined />} placeholder="مثلا علی محمدی"/>
                        </Form.Item>
                        <Form.Item className="w-full  ">
                            <Button loading={isLoading} size="large" type="primary" className="bg-primary w-full  "
                                    htmlType="submit">
                                مرحله بعد
                            </Button>
                        </Form.Item>
                    </Form>
                </>

            }

        </div>

    </Container>
}
export default Login;